import { observable } from 'mobx';
import { DEFAULT_MATCH_THRESHOLD } from '../constants';

class FaceStore {
  @observable matchThreshold = DEFAULT_MATCH_THRESHOLD;
}

export default new FaceStore();
